export default __webpack_public_path__ + "static/media/sideFullSync.0954e352.svg";